<template>
  <div>
    <div class="center-between mb-4">
      <h1 class="m-0" v-text="$t('paymentTerminal.label', 2)" />
      <button
        class="small"
        @click="$store.dispatch('modals/openModal', { modal: 'editPaymentTerminal', entity: {
          name: '',
          ipAddress: '',
          store: `/stores/${$route.params.storeId}`,
        } })"
      >
        +
      </button>
    </div>

    <entity-table
      v-model:sortBy="sortBy"
      v-model:sortDirection="sortDirection"
      :fields="fields"
      :entities="entities"
      :loading="loadingEntities"
      :current-page="currentPage"
      :total-items="totalItems"
      @click:edit="$store.dispatch('modals/openModal', { modal: 'editPaymentTerminal', entity: normalizeEntity($event) })"
      @click:delete="$store.dispatch('modals/openModal', { modal: 'deletePaymentTerminal', entity: $event })"
      @update:sort="loadEntities()"
      @update:page="currentPage = $event; loadEntities()"
    />

    <edit-payment-terminal-modal @update="loadEntities" />
    <delete-modal type="deletePaymentTerminal" entity-translation-key="paymentTerminal" label="name" @update="loadEntities" />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import useEntityFields from '@/hooks/api/fields';
import useLoadEntities from '@/hooks/api/loadEntities';
import EntityTable from '@/components/shared/EntityTable/EntityTable.vue';
import EditRegisterModal from '@/components/entities/register/EditRegisterModal.vue';
import EditPaymentTerminalModal from '@/components/entities/payment_terminal/EditPaymentTerminalModal.vue';
import DeleteModal from '@/components/shared/DeleteModal.vue';

export default {
  name: 'PaymentTerminalIndexPage',
  components: {
    DeleteModal,
    EditPaymentTerminalModal,
    EditRegisterModal,
    EntityTable,
  },
  setup() {
    const route = useRoute();
    const { paymentTerminal: fields } = useEntityFields();
    const {
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities,
    } = useLoadEntities('/payment_terminals', {
      sort: 'name',
      defaultParams: {
        store: route.params.storeId,
      },
    });

    const normalizeEntity = (entity) => ({
      ...entity,
      store: entity?.store?.['@id'],
    });

    return {
      fields,
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities,
      normalizeEntity,
    };
  },
};
</script>
